import './App.css';
import { useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { CartProvider } from './context/CartContext';
import Header from './components/Header';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import CookieConsentBanner from './components/CookieConsentBanner';
import EmailCapturePopup from './components/EmailCapturePopup';
import Home from './pages/Home';
import Shop from './pages/Shop';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Shipping from './pages/Shipping';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import SexReloaded from './pages/SexReloaded';
import { captureUTMs, trackPageView } from './utils/metaPixel';
import { captureAclid } from './utils/trafficJunky';

// Routes that suppress the global Header/Footer (focused landing pages)
const BARE_ROUTES = ['/pages/sex-reloaded'];

// Safety net: if Shopify sends a /checkouts/* URL to this domain, forward to Shopify
function CheckoutRedirect() {
  useEffect(() => {
    window.location.replace(
      'https://mencore-2.myshopify.com' + window.location.pathname + window.location.search
    );
  }, []);
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', fontFamily: 'Manrope, sans-serif', color: '#64748B', fontSize: '0.9rem' }}>
      Redirecting to checkout...
    </div>
  );
}

/** Fires Meta Pixel PageView on React Router navigations — now inlined in AppLayout */

function App() {
  // Capture UTM params + TrafficJunky aclid once on landing so they survive
  // React Router navigation and the Shopify checkout handoff.
  useEffect(() => {
    captureUTMs();
    captureAclid();
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <CartProvider>
          <AppLayout />
        </CartProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

function AppLayout() {
  const location = useLocation();
  const isBarePage = BARE_ROUTES.includes(location.pathname);

  // Track Meta Pixel PageView on React Router navigations.
  // Skips initial mount — initPixel() handles the first PageView.
  const initialMount = useRef(true);
  useEffect(() => {
    if (initialMount.current) { initialMount.current = false; return; }
    trackPageView();
  }, [location.pathname]);

  return (
    <div style={{ backgroundColor: '#F7F7F5', minHeight: '100vh' }}>
      <CookieConsentBanner />
      <EmailCapturePopup />
      <CartDrawer />
      {!isBarePage && <Header />}
      <Routes>
        <Route path="/checkouts/*" element={<CheckoutRedirect />} />
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/shipping" element={<Shipping />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/pages/sex-reloaded" element={<SexReloaded />} />
      </Routes>
      {!isBarePage && <Footer />}
    </div>
  );
}

export default App;
